/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import isEqual from 'lodash/isNil';
import config from 'loracfg';


const propTypes = {
  children: React.PropTypes.any,
  plan: React.PropTypes.object,
};

class ExpireLatch extends React.Component {

  componentWillMount() {
    this.checkExpire();
  }

  componentWillReceiveProps(nextProps) {
    const { plan } = nextProps;
    if (!isEqual(plan, this.props.plan)) {
      this.setState({ plan });
    }
    this.checkExpire(nextProps);
  }

  checkExpire(props = this.props) {
    if (config.profile === 'cube') {
      return;
    }
    const {
      plan: { data: planData = {} },
      gotoBilling,
    } = props;
    if (planData.expired) {
      gotoBilling();
    }
  }

  render() {
    return (
      <div>{this.props.children}</div>
    );
  }
}

ExpireLatch.propTypes = propTypes;


const mapStateToProps = state => ({
  plan: state.billing.plan,
});

const mapDispatchToProps = dispatch => ({
  gotoBilling: () => dispatch(push('/billing')),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExpireLatch);




// WEBPACK FOOTER //
// ./src/containers/ExpireLatch.jsx